import roleApi from '@/api/role'

const role={
  namespaced:true,
  state:{
    data:[],
    pagination:{current:1,total:0,pageSize:10,showSizeChanger:true,showTotal:total=>`总计 ${total} 条`},
    loading:false,
    editRole:{permissions:[]},
    sorter:{},
    schools:[],
    permissions:[]
  },
  mutations:{
    setData:(state,data)=>{
      state.data=data
    },
    setPagination:(state,pagination)=>{
      state.pagination=pagination
    },
    setLoading:(state,loading)=>{
      state.loading=loading
    },
    edit:(state,role)=>{
      state.disabled=false
      state.editRole=role
    },
    setSorter:(state,sorter)=>{
      state.sorter=sorter
    },
    setSchools:(state,schools)=>{
      state.schools=schools
    },  
    setPermissions:(state,permissions)=>{
      state.permissions=permissions
    }
  },
  actions:{
    async GetAll({ commit,state },pagination){
      commit('setLoading',true)
      const page={
        skipCount:pagination.pageSize*(pagination.current-1),
        maxResultCount:pagination.pageSize,
        ...pagination
      }           
      if(state.sorter.field){
        if(state.sorter.order==='ascend'){
          page.sorting=state.sorter.field
        }else{
          page.sorting=state.sorter.field+' desc'
        }
      }
      try{
        const res=await roleApi.getAll(page)
        pagination.total=res.result.totalCount
        commit('setPagination',pagination)
        commit('setData',res.result.items)
      }finally {
        commit('setLoading',false)
      }
    },
    async UpdateOrAdd({ dispatch,state },user){
      try{
        if(user.id){
          await roleApi.update(user)          
        }else{
          await roleApi.create(user)
        }
        await dispatch('GetAll',state.pagination)
      }catch(err){
        throw err
      }     
    },
    async Delete({ dispatch,state },role){
      await roleApi.delete(role.id)
      await dispatch('GetAll',state.pagination)
    },
    async GetSchools({ commit }){
      const res=await roleApi.getSchools()
      commit('setSchools',res.result.items)
    },
    async GetAllPermissions({ commit }){
      const res=await roleApi.getAllPermissions()
      commit('setPermissions',res.result.items)
    }
  }
}
export default role